module.exports = __webpack_public_path__ + "img/Xgrow-5-pt.776f9cc0.png";